import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { speak } from '../utils/sounds';

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    speak('Bienvenue ! Clique pour commencer à apprendre en t\'amusant !');
  }, []);

  const handleStart = () => {
    navigate('/subjects');
  };

  return (
    <div>
      <div className="header">
        <h1 className="float">🎓 Mon Enfant 🎨</h1>
        <p>Apprendre en s'amusant !</p>
      </div>

      <div className="card" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '5rem', marginBottom: '30px' }}>
          📚 ✏️ 🔢 🎵
        </div>
        <h2 style={{ fontSize: '2.5rem', color: '#667eea', marginBottom: '30px' }}>
          Bienvenue petit champion !
        </h2>
        <p style={{ fontSize: '1.5rem', marginBottom: '40px', color: '#666' }}>
          Clique sur le bouton pour commencer ton aventure d'apprentissage
        </p>
        <button
          className="btn btn-primary bounce"
          onClick={handleStart}
          style={{ fontSize: '2rem', padding: '25px 60px' }}
        >
          🚀 Commencer
        </button>
      </div>
    </div>
  );
};

export default Home;
